import { EmployeeQcqCompetenceResponse, EmployeeQcqCompetenceItem } from '@/types/service-response'
import { EmployeeQcqCompetencePayload } from '@/types/payload'

export class EmployeeQcqCompetence {
  private constructor (
    readonly id: number | null,
    readonly competenceId: number | null,
    readonly quality: number | null,
    readonly description: string | undefined,
  ) {}

  public static createFromResponse (data: EmployeeQcqCompetenceResponse): Array<EmployeeQcqCompetence> {
    let result: Array<EmployeeQcqCompetence> = []

    data.forEach((item: EmployeeQcqCompetenceItem) => {
      result.push(new EmployeeQcqCompetence(
        item.ID,
        item.CompetenceID,
        item.Quality,
        item.Bezeichnung,
      ))
    })

    return result
  }

  public static createFromData (data: EmployeeQcqCompetencePayload): EmployeeQcqCompetence {
    let result: EmployeeQcqCompetence = new EmployeeQcqCompetence(
      data.id,
      data.competenceId,
      data.quality,
      data.description
    )

    return result
  }
}